import { Component, Input } from '@angular/core';
import { ICellConfig } from '../base-cell/base-cell.component';
import { BaseCellComponent } from '../base-cell/base-cell.component';

export interface IListItemData {
  text: string;
}

export interface IDSListCellConfig extends ICellConfig {
  items: IListItemData[];
}

@Component({
  selector: 'table-cell-ds-list',
  styleUrls: ['../base-cell/base-cell.component.scss'],
  standalone: false,
  template: `
    <ul #ref>
      @for (item of config.items; track item; let isLast = $last) {
        <li [ngClass]="{ 'mb-3': !isLast }">{{ item.text }}</li>
      }
    </ul>
  `,
})
export class DsListCellComponent extends BaseCellComponent {
  @Input() public config: IDSListCellConfig;
}
